import ResetPassword from 'pages/Views/ResetPassword';
import UserDefinitions from 'pages/Views/UserDefinitions';
import ProfileInfo from 'pages/Views/ProfileInfo';
import * as React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DeliveryMethodView from 'pages/Views/DeliveryMethod';

const ProtectedRoute = React.lazy(() => import('./ProtectedRoute'));

const ExpressLanding = React.lazy(() => import('pages/Views/ExpressLanding'));
const Register = React.lazy(() => import('pages/Views/Register'));
const Login = React.lazy(() => import('pages/Views/ExpressLogin'));
const PreSignUp = React.lazy(() => import('pages/Views/PreSignUp'));
const Landing = React.lazy(() => import('pages/Views/Landing'));
const Current = React.lazy(() => import('pages/Views/Current'));
const Archive = React.lazy(() => import('pages/Views/Archive'));
const CreateCurrent = React.lazy(() => import('pages/Views/CreateCurrent'));
const Address = React.lazy(() => import('pages/Views/Address'));
const Currency = React.lazy(() => import('pages/Views/Currency'));
const AddressDetail = React.lazy(() => import('pages/Views/AddressDetail'));
const AddressCreate = React.lazy(() => import('pages/Views/AddressCreate'));
const Roles = React.lazy(() => import('pages/Views/Roles'));
const Permission = React.lazy(() => import('pages/Views/Permission'));
const AddressUpdate = React.lazy(() => import('pages/Views/AddressUpdate'));
const ServiceType = React.lazy(() => import('pages/Views/ServiceType'));
const StatusType = React.lazy(() => import('pages/Views/StatusType'));
const Prices = React.lazy(() => import('pages/Views/Prices'));
const DeliveryType = React.lazy(() => import('pages/Views/DeliveryType'));
const ContainerType = React.lazy(() => import('pages/Views/ContainerType'));
const DocumentType = React.lazy(() => import('pages/Views/DocumentType'));
const Shipments = React.lazy(() => import('pages/Views/Shipments'));
const CustomersShipments = React.lazy(() =>
  import('pages/Views/CustomersShipments')
);
const ShipmentDetail = React.lazy(() => import('pages/Views/ShipmentDetail'));
const ShipmentReport = React.lazy(() => import('pages/Views/ShipmentReport'));
const UserCheckReport = React.lazy(() => import('pages/Views/UserCheckReport'));
const CreateShipment = React.lazy(() => import('pages/Views/CreateShipment'));
const BookService = React.lazy(() => import('pages/Views/BookService'));
const BookServiceGroup = React.lazy(() => import('pages/Views/BookServiceGroup'));
const ForgetPassword = React.lazy(() => import('pages/Views/ForgetPassword'));
const NotFound = React.lazy(() => import('pages/Views/404'));
const EditUser = React.lazy(() => import('pages/Views/EditUser'));

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <React.Suspense fallback={<>...</>}>
              <ExpressLanding />
            </React.Suspense>
          }
        />
        <Route
          path="/login"
          element={
            <React.Suspense fallback={<>...</>}>
              <Login />
            </React.Suspense>
          }
        />
        <Route
          path="/edit-user/:id"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <EditUser />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-user/:type"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <EditUser />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/forgotpassword"
          element={
            <React.Suspense fallback={<>...</>}>
              <ForgetPassword />
            </React.Suspense>
          }
        />
        <Route
          path="/reset-password/:code"
          element={
            <React.Suspense fallback={<>...</>}>
              <ResetPassword />
            </React.Suspense>
          }
        />
        <Route
          path="/signup"
          element={
            <React.Suspense fallback={<>...</>}>
              <PreSignUp />
            </React.Suspense>
          }
        />
        <Route
          path="/register"
          element={
            <React.Suspense fallback={<>...</>}>
              <Register />
            </React.Suspense>
          }
        />
        <Route
          path="/landing"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <Landing />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/cari"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <Current />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dijital-arsiv"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <Archive />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/cari-olustur"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <CreateCurrent />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/cari/:id"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <CreateCurrent />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/adresler"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <Address />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/roller"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <Roles />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/yetki-tanimlama"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <Permission />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/adres/:id"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <AddressDetail />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/adres-guncelle/:currentId/:id"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <AddressUpdate />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/adres-ekle/:id"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <AddressCreate />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/adres-ekle"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <AddressCreate />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/gonderiler"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <Shipments />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/gonderiler/:id"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <CustomersShipments />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/gonderi/:id"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <ShipmentDetail />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/konsimento-raporu"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <ShipmentReport />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/kullanici-kontrol-raporu"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <UserCheckReport />
              </React.Suspense>
            </ProtectedRoute>
          }
        />

        <Route
          path="/gonderiler"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <Shipments />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/gonderiler/:id"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <CustomersShipments />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/gonderi/:id"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <ShipmentDetail />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/gonderi/olustur/:id"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <CreateShipment />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/gonderi/duzenle/:id/:shipmentId"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <CreateShipment />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/kullanici-tanimlama"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <UserDefinitions />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/servisler"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <BookService />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/servis-tipleri"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <ServiceType />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/teslimat-tipleri"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <DeliveryType />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/teslimat-bicimleri"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <DeliveryMethodView />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/kap-turleri"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <ContainerType />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/evrak-tipi-tanimlama"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <DocumentType />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/para-birimleri"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <Currency />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profil"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <ProfileInfo />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/durum-tipleri"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <StatusType />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/fiyatlar"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <Prices />
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/servis-gruplari"
          element={
            <ProtectedRoute>
              <React.Suspense fallback={<>...</>}>
                <BookServiceGroup/>
              </React.Suspense>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
